"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const chart_helpers_1 = require("../../util/chart.helpers");
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
const defaultMargins = {
  top: 20,
  bottom: 50,
  left: 0,
  right: 10,
  xAxis: 10,
  minRightLabel: 0,
  maxRightLabelRatio: undefined
};
const lineStyles = {
  default: {
    name: 'default',
    colourFunction: (chart, d, i, params) => (0, chart_helpers_1.getColour)(d, i, params),
    dataSelector(d) {
      const fips = d.selector || d.fips;
      return `${d.metric.id}${fips ? `-${fips}` : ''}`;
    },
    externalHoverOpacities: {
      inactive: 0.25,
      hovered: 0.5,
      active: 1
    },
    lineHoverOpacities: {
      inactive: 0.25,
      hovered: 0.25,
      active: 1
    },
    margins: defaultMargins,
    showInactiveLabels: true,
    strokeWidth: (d, params, isSubchart) => d.lineSize || params.lineSize || (isSubchart ? 2 : null)
  },
  spaghetti: {
    name: 'spaghetti',
    colourFunction(chart, d, i, params) {
      if (chart.isHighlighted(d, params)) {
        if (d.primaryColor) {
          return d.primaryColor;
        }
        if (d.states !== undefined) {
          const state = d.states.find(dd => dd.fips === d.fips);
          if (state && state.primaryColor) return state.primaryColor;
        }
        if (params.primaryColor) {
          return params.primaryColor;
        }
        return colours_module_scss_1.default.chartcolourdefault0;
      }
      return colours_module_scss_1.default.chartcolourgrey;
    },
    dataSelector(d) {
      return d.selector || d.fips;
    },
    legendShowBox(chart, d, params) {
      return chart.isHighlighted(d, params);
    },
    legendSortOrder(a, b) {
      if (a.selector === 'US') return -1;
      if (b.selector === 'US') return 1;
      return 0;
    },
    externalHoverOpacities: {
      inactive: 0.25,
      hovered: 1,
      active: 1
    },
    lineHoverOpacities: {
      inactive: 0.25,
      hovered: 1,
      active: 1
    },
    margins: {
      ...defaultMargins,
      left: 0,
      xAxis: 20
    },
    showInactiveLabels: false,
    strokeWidth: d => d.lineSize || 2
  }
};
exports.default = lineStyles;